<template>

  <div v-if="botErrors && Object.keys(botErrors).length > 0" class="alert alert-danger border-0 mt-0 mb-0" role="alert">
    <div class="d-flex flex-row align-items-center mb-3">
      <div class="bg-danger me-3 icon-item"><span class="fas fa-info-circle text-white fs-6"></span></div>
      <p class="mb-0 flex-1">
        <span class="fw-bold">Some Bots have errors:</span><br>
        <b>Possible reasons:</b> API Key expired, missing API Key permissions, wrong IP Address set, etc.<br>
        <b>What to do:</b> Try to fix it and reload the Edit Bot Page to force SIGNUM to try again. If it persists, delete the Bot in question and create it again with fresh API Keys to be sure it works. Don't forget to update your Trading Alerts afterwards.
      </p>
    </div>
    <div class="flex-row">
      <div class="table-responsive scrollbar">
        <table class="table table-hover table-borderless table-sm fs-10 mb-0 overflow-hidden">
          <!-- <thead class="bg-200">
            <tr>
              <th class="text-900 align-middle white-space-nowrap">Bot</th>
              <th class="text-900 align-middle white-space-nowrap">Error</th>
            </tr>
          </thead> -->
          <tbody class="list">
            <tr v-for="(errorObj, botId) in botErrors" :key="botId" class="">
              <td class="pe-3 py-2 align-middle white-space-nowrap">
                <router-link :to="{name: 'EditBot', params: {id: botId}}">
                  <span :class="'fw-bold '+botId">{{ getBotById(botId).title }}</span>
                </router-link>

              </td>
              <td class="py-2 align-middle white-space-nowrap">
                {{ getFormattedLogMessage(errorObj.error) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  computed: {
    userProfile () {
      return this.$store.getters.getUserProfile
    },
    userBots () {
      return this.$store.getters.getUserBots
    },
    botErrors () {
      return this.$store.getters.getUserBotErrors
    }
  },
  methods: {
    getBotById (id) {
      return this.userBots?.find(elem => elem.id == id)
    },
    getFormattedLogMessage (message) {
      return message.charAt(0).toUpperCase() + message.slice(1)
    }
  },
  async mounted () {
  }
}
</script>

<style scoped>
  
</style>